import Component from 'component';
import _debounce from 'lodash/debounce';
import _template from 'lodash/template';
import _remove from 'lodash/remove';
import _isEmpty from 'lodash/isEmpty';
import predictiveTmpl from 'templates/predictive-search-item';
import { ENDPOINT, SEARCH_GROUPS } from '../../constants';
import { Expo, TweenLite } from 'gsap';

class PredictiveSearch extends Component {
  constructor(el, config){
    super(el, config);
  }

  setupDefaults(){
    this.dom = {
      $container: this.$el,
      $serchBox: this.$el.find('.wh-search-box'),
      $input: this.$el.find('.wh-search-box__field'),
      $searchBtn: this.$el.find('.wh-search-box__button'),
      $results: this.$el.find('.wh-predictive-search')
    };

    this.cssClasses= {
      searchGroup: 'wh-predictive-search-group'
    };

    this.endpoint = (this.config.endpoint) ? this.config.endpoint : ENDPOINT.getKeywordSearch;
    this.currentRequest = [];
  }

  addListeners(){
    this.dom.$input.on('keyup input', _debounce(e => {
      this.onInputUp(e);
    }, 100));

    this.dom.$searchBtn.on('click touch', ::this.onSearch);
    this.$el.on('click touch', '.wh-predictive-search-group__title', ::this.onHeadingClick);
  }

  getResults(keyword, contenttype, requestIndex) {
    this.dom.$serchBox.addClass('loading');
    return $.ajax({
      url: this.endpoint,
      data: { keyword, contenttype, take: this.config.itemsLimit ? this.config.itemsLimit : undefined },
      beforeSend: () => {
        if (this.currentRequest[requestIndex] && this.currentRequest[requestIndex] !== null) {
          this.currentRequest[requestIndex].abort();
        }
      }
    });
  }

  async renderResults(value) {

    const data = await Promise.all([
      this.currentRequest[0] = this.getResults(value, SEARCH_GROUPS[0], 0),
      this.currentRequest[1] = this.getResults(value, SEARCH_GROUPS[1], 1),
      this.currentRequest[2] = this.getResults(value, SEARCH_GROUPS[2], 2),
      this.currentRequest[3] = this.getResults(value, SEARCH_GROUPS[3], 3),
      this.currentRequest[4] = this.getResults(value, SEARCH_GROUPS[4], 4),
      this.currentRequest[5] = this.getResults(value, SEARCH_GROUPS[5], 5),
      this.currentRequest[5] = this.getResults(value, SEARCH_GROUPS[6], 6),
      this.currentRequest[5] = this.getResults(value, SEARCH_GROUPS[7], 7),
      this.currentRequest[5] = this.getResults(value, SEARCH_GROUPS[8], 8),
      this.currentRequest[5] = this.getResults(value, SEARCH_GROUPS[9], 9)
    ]);

    _remove(data, n => _isEmpty(n));

    this.dom.$serchBox.removeClass('loading');
    this.$el.trigger('search:keyword', data);

    let items = '';

    if (data.length > 0) {
      data.forEach(item => {
        items += _template(predictiveTmpl)(item);
      });

      this.dom.$results.html(items);


    } else {
      const noResults = this.dom.$results.data('no-results-txt');
      const noResultsString = '<li class="wh-predictive-search__none">' + noResults + '</li>';

      this.dom.$results.find('li').remove();
      this.dom.$results.html(noResultsString);
    }

    this.dom.$results.removeClass('loading');

    if (!this.dom.$results.hasClass('expanded')) {
      this.dom.$results.addClass('expanded');
      TweenLite.set(this.dom.$results, { height: 'auto', ease:Expo.easeOut });
      TweenLite.from(this.dom.$results, 0.4, { height: 0, ease:Expo.easeInOut });
    }

  }

  destroyResults(){
    TweenLite.to(this.dom.$results, 0.5, { height: 0, ease:Expo.easeOut, onComplete: () => {
      this.dom.$results.removeClass('expanded');
      this.dom.$results.find('li').remove();
    } });
  }

  onInputUp(e) {
    const value = this.dom.$input.val().trim();

    if (value.length < 1){
      this.destroyResults();

      return;
    }

    if (value.length >= 1) {
      this.dom.$searchBtn.addClass('active');
    } else {
      this.dom.$searchBtn.removeClass('active');
    }

    if (e.which === 13) {
      this.destroyResults();
      window.open(`${this.dom.$serchBox.data('search-url')}?keyword=${encodeURIComponent(value)}`, '_self');
      return;
    }

    this.renderResults(value)
      .catch(err => {
        if (err.statusText !== 'abort') {
          console.error('There was an error getting your results', err);
        }
      });
  }

  onHeadingClick(e) {
    const $target = $(e.currentTarget);
    if ($target.hasClass('wh-predictive-search-group__title--false')) {
      return;
    }

    const $searchGroup = $target.parents(`.${this.cssClasses.searchGroup}`);
    const searchViewAllType = $searchGroup.data('predictive-view-all-type');
    let searchGroupLabel = $searchGroup.data('predictive-search-group');

    if (searchGroupLabel === 'Solutions' || searchGroupLabel === 'Locations' || searchGroupLabel === 'Careers') {
      searchGroupLabel = searchGroupLabel.substring(0, searchGroupLabel.length - 1);
    }

    const keyword = this.dom.$input.val().trim();
    window.open(
      `${this.dom.$serchBox.data('search-url')}?area=${searchViewAllType ? encodeURIComponent(searchViewAllType) : encodeURIComponent(searchGroupLabel)}&keyword=${encodeURIComponent(keyword)}`,
       '_self'
      );
  }

  onSearch(e){
    e.preventDefault();
    const keyword = this.dom.$input.val().trim();
    this.destroyResults();
    window.open(`${this.dom.$serchBox.data('search-url')}?keyword=${encodeURIComponent(keyword)}`, '_self');
  }
}

export default PredictiveSearch;



// WEBPACK FOOTER //
// ./src/js/components/global/PredictiveSearch.js